enum LayerInfosActions {
  ADD_LAYER_INFOS = '[layerInfos] Add layer infos',
  CLEAR_FAILED_RECORDS = '[layerInfos] Clearing failed records. Sources are imported again',
  CLEAR_ALL_DATA = '[layerInfos] Clear all data',
  SET_VISIBLE_LAYERS = '[layerInfos] layer visibility changed',
  ADD_VISIBLE_LAYERS = '[layerInfos] ADD_VISIBLE_LAYERS',
  SET_HIDDEN_GROUP_CACHE = '[layerInfos] Set hidden group layers cache',
  VECTOR_LEGEND_IMAGES_LOADED = '[layerInfos] VECTOR_LEGEND_IMAGES_LOADED',
  SET_LOADING_LAYERS = '[layerInfos] Set loading layers'
}
export default LayerInfosActions
